import React, {Component} from 'react';
import {Row, Col, Input, Button, Form, Select, Icon, Modal, Table, Tag, Popconfirm} from 'antd';
import Card from '../../components/Card';
import TeamSeleted from '../../components/TeamSeleted';
import {api, app} from "../../app";
import utils from "../../utils";

const FormItem = Form.Item;
const Option = Select.Option;

/**
 * 补零
 * @param len
 * @param val
 * @returns {*}
 */
function upZero(len, val) {
    let vlen = val.length;
    if (vlen < len) {
        for (let i = 0; i < len - vlen; i++) {
            val = '0' + val;
        }
    }
    return val;
}

/**
 * 检测
 * @param start_coding
 * @param end_coding
 * @param prefix
 * @returns {*}
 */
function check(start_coding, end_coding, prefix = '') {
    let plen = 6 - prefix.length;
    let reg = new RegExp(`[0-9]{${plen}}`);
    if (!reg.test(start_coding)) {
        app.alert('开始编码请输入正确的数字格式！', 'warn');
        return false;
    }
    if (!reg.test(end_coding)) {
        app.alert('结束编码请输入正确的数字格式！', 'warn');
        return false;
    }
    let start = parseInt(start_coding);
    let end = parseInt(end_coding);
    let i = start;
    let len = end;
    let state = {
        codes: [],
        start_coding,
        end_coding,
    };
    if (start > end) {
        i = end;
        len = start;
        state.start_coding = end_coding;
        state.end_coding = start_coding;
    }
    if (len - i > 9) {
        app.alert('开始结束编码范围最大为10！', 'warn');
        return false;
    }
    return {i, len, plen, state};
}

class TeamHonorEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            select_team: {},
            rights: app.getData("rights"),
            rycodeList: [],
            codes: [],
            start_coding: '',
            end_coding: '',
            fix_flag: 0,
            ptotal: 0,
            ppage: 1,
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 设置值
     * @param data
     */
    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    /**
     * 选择队伍
     * @param e
     */
    handleSelectTeam = async (team) => {
        await this.setData({fix_loading: true});
        team.prefix = await this.handlePrefix(team.teamno);
        await this.setData({select_team: team, fix_loading: false});
        // await this.handleShowRYCode();
    }

    /**
     * 获取编号
     * @param type
     * @returns {Promise<any.data>}
     */
    handleGetCode = async (type) => {
        let {select_team} = this.state, params = {
            type,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            teamno: select_team.teamno,
        };
        let {flag, data, msg} = await app.post(api.CheckTvhp, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        return utils.addArrayKey(data);
    }

    /**
     * 获取人员列表
     * @param ppage
     * @returns {Promise<any.data>}
     */
    handlePlayerData = async (ppage) => {
        await this.setData({ppage, plist_loading: true});
        let {select_team} = this.state, params = {
            page: ppage,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            teamno: select_team.teamno,
        };
        let {flag, data, msg, total} = await app.post(api.HonorbBsrnoList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (ppage === this.state.ppage) {
            await this.setData({plist_loading: false, playerList: utils.addArrayKey(data), ptotal: parseInt(total || 0)});
        }
    }

    /**
     * 删除编号
     * @param id
     * @param type
     * @param index
     * @returns {Promise<void>}
     */
    handleDeleteCode = async (id, type, index) => {
        const params = {
            id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let {flag, msg} = await app.post(api.TvhpDel, params);
        if (flag === 1) {
            if (type === 1) {
                let {rycodeList} = this.state;
                rycodeList.splice(index, 1);
                await this.setData({rycodeList});
            } else if (type === 2) {
                let {posicodeList} = this.state;
                posicodeList.splice(index, 1);
                await this.setData({posicodeList});
            }
            app.alert("删除成功", "success");
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 选择人员
     * @param id
     * @param teamno
     * @param index
     * @returns {Promise<void>}
     */
    handleSelectPalyer = async (id, teamno) => {
        let {select_bsrno} = this.state, params = {
            id,
            teamno,
            bsrno: select_bsrno,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let {flag, msg} = await app.post(api.HonorbBsrnoApply, params);
        if (flag === 1) {
            app.alert("选择成功, 等待审核", "success", "40%", 3);
            await this.handleClosePlayer();
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 获取荣誉前缀
     */
    handlePrefix = async (teamno) => {
        let {flag, data, msg} = await app.post(api.HonorbBsrnoCode, {
            teamno,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        });
        if (flag === 1) {
            await this.setData({fix_flag: 1});
        } else {
            app.alert(msg, "warn");
            data = '';
            await this.setData({fix_flag: 0});
        }
        return data;
    }

    /**
     * 查看荣誉编号
     */
    handleShowRYCode = async () => {
        await this.setData({ry_loading: true});
        let rycodeList = await this.handleGetCode(1);
        await this.setData({rycodeList, ry_loading: false});
    }

    /**
     * 关闭荣誉编码弹框
     */
    handleCloseRYCode = async () => {
        await this.setData({ry_modal: false, rycodeList: []});
    }

    /**
     * 打开荣誉编码弹框
     */
    handleOpenRYCode = async () => {
        await this.setData({ry_modal: true});
        await this.handleShowRYCode();
    }

    /**
     * 关闭荣誉编码选人弹框
     */
    handleClosePlayer = async () => {
        await this.setData({plist_visible: false, palyerList: []});
    }

    /**
     * 打开荣誉编码选人弹框
     */
    handleOpenPlayer = async (bsrno) => {
        await this.setData({plist_visible: true, select_bsrno: bsrno});
        await this.handlePlayerData(1);
    }

    /**
     * 编辑队伍信息
     * @param e
     */
    handleEditTeam = async () => {
        if (this.state.edit_loading) return false;
        await this.setData({edit_loading: true});
        let {start_coding, end_coding, select_team} = this.state;
        let res = check(start_coding, end_coding, select_team.prefix);
        if (!res) return;
        let {flag, msg} = await app.post(api.HonorbBsrno, {
            teamno: select_team.teamno,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            start_coding: res.state.start_coding,
            end_coding: res.state.end_coding,
        });
        let state = {edit_loading: false};
        if (flag === 1) {
            app.alert("提交成功", "success");
        } else {
            app.alert(msg, "error");
        }
        await this.setData(state);
    }

    //开始编码
    handleStartCode = async (e) => {
        let {value} = e.target;
        await this.setData({start_coding: value});
    }
    /**
     * 结束编码
     * @param e
     * @returns {Promise<void>}
     */
    handleEndCode = async (e) => {
        let {value} = e.target;
        await this.setData({end_coding: value});
    }

    /**
     * 预览
     * @returns {Promise<void>}
     */
    handlePreviewClick = async () => {
        let {start_coding, end_coding, select_team} = this.state;
        let res = check(start_coding, end_coding, select_team.prefix);
        if (!res) return;
        let {state, i, len, plen} = res;
        for (; i <= len; i++) {
            let code = select_team.prefix + upZero(plen, i + '');
            state.codes.push(code)
        }
        await this.setData(state);
    }

    render() {
        let {
                select_team, edit_loading, fix_flag, codes, ry_modal, start_coding, ry_loading, fix_loading, rycodeList,
                plist_visible, plist_loading, ptotal, playerList,
            } = this.state,
            columns = [
                {
                    title: '编号',
                    dataIndex: 'hp_bsrno',
                    key: 'hp_bsrno',
                    width: '15%',
                },
                {
                    title: '使用情况',
                    dataIndex: 'use_status',
                    key: 'use_status',
                    width: '15%',
                    render(text) {
                        return (<span>{text === "1" ? "已使用" : "未使用"}</span>);
                    }
                },
                {
                    title: '审核情况',
                    dataIndex: 'status',
                    key: 'status',
                    width: '20%',
                    render(text) {
                        return (<span>{text === 1 ? "已通过" : "未通过"}</span>);
                    }
                },
                {
                    title: '使用人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '20%',
                    render(text) {
                        return (<span>{text || ""}</span>);
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '30%',
                    render: (id, {use_status, status, hp_bsrno}, index) => {
                        let nodes = [];
                        if (status === 1) {
                            if (use_status === "1") {
                                // nodes.push(<Button size="small" key="2" className="team-edit-delete">重置</Button>);
                            } else {
                                nodes.push(<Button type="primary" size="small" key="1" onClick={() => this.handleOpenPlayer(hp_bsrno)}
                                                   className="team-edit-delete">选择成员</Button>);
                            }
                        }
                        nodes.push(
                            <Popconfirm title="确定删除吗？" onConfirm={() => this.handleDeleteCode(id, 1, index)} okText="确定" cancelText="取消">
                                <Button type="danger" size="small" key="3" className="team-edit-delete">删除</Button>
                            </Popconfirm>);
                        return (<div style={{textAlign: 'right'}}>{nodes}</div>);
                    }
                },
            ],
            columns2 = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '20%',
                },
                {
                    title: '编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '20%',
                },
                {
                    title: '职位',
                    dataIndex: 'teampositionname',
                    key: 'teampositionname',
                    width: '20%',
                    render(text) {
                        return (<span>{text || '暂无'}</span>);
                    }
                },
                {
                    title: '身份',
                    dataIndex: 'state',
                    key: 'state',
                    width: '20%'
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '20%',
                    render: (id) => {
                        return (
                            <Button type="primary" size="small" className="team-edit-delete"
                                    onClick={() => this.handleSelectPalyer(id, select_team.teamno)}>选择</Button>
                        );
                    }
                },
            ],
            prefix = fix_loading ? (<Icon type="loading" theme="outlined"/>) : select_team.prefix;
        return (
            <div className="team-editor">
                <div className="top-title">荣誉编码</div>
                <Row className="content">
                    <Col span={6} className="team-select">
                        <TeamSeleted handleData={this.handleSelectTeam}/>
                    </Col>
                    <Col span={17} offset={1} className="team-info">
                        {
                            fix_flag === 0 ? null :
                                (
                                    <Card width="100%" height="100%"
                                          style={{padding: "40px 25px", height: 'calc(100% - 68px)', overflow: "auto"}}
                                          title={select_team.teamname || "队伍名称"}>
                                        <div style={{color: 'red', width: 600, margin: '30px auto'}}>
                                            注：编号预留必须输入完整编号，存心编号始终为6位; 例如：云A0001。<br/>
                                            <span
                                                style={{paddingLeft: 28}}>如果只添加单个号码, 左右两边填写同一个编码即可; 荣誉编码最多只能设置10个。</span>
                                        </div>
                                        <Row type="flex" align="middle">
                                            <Col span={7} style={{textAlign: 'right'}}>设置荣誉编号预留：</Col>
                                            <Col style={{width: 300, display: 'inin'}} offset={1}>
                                                <Input addonBefore={prefix} style={{width: 120}}
                                                       maxLength={6 - (select_team.prefix || '').length}
                                                       onBlur={this.handleStartCode}/>
                                                <span style={{padding: '0 10px'}}> - </span>
                                                <Input addonBefore={prefix} readOnly={!start_coding}
                                                       style={{width: 120}}
                                                       maxLength={6 - (select_team.prefix || '').length}
                                                       onBlur={this.handleEndCode}/>
                                            </Col>
                                            <Col span={3}>
                                                <Button type="primary" size="small"
                                                        onClick={() => this.handlePreviewClick()}>预览</Button>
                                            </Col>
                                        </Row>
                                        <Row style={{margin: '20px 0'}}>
                                            <Col offset={7} className="codes">
                                                {
                                                    codes.map((c, i) => {
                                                        return (<Tag color="#2db7f5" key={i}
                                                                     style={{marginBottom: 10}}>{c}</Tag>);
                                                    })
                                                }
                                            </Col>
                                        </Row>
                                        <div style={{textAlign: 'center'}}>
                                            <Button type="primary" onClick={() => this.handleOpenRYCode()}
                                                    style={{marginRight: 20}}>查看</Button>
                                            <Button type="primary" onClick={() => this.handleEditTeam()}
                                                    loading={edit_loading}>提交</Button>
                                        </div>
                                    </Card>
                                )
                        }
                    </Col>
                </Row>
                <Modal
                    visible={ry_modal}
                    onCancel={this.handleCloseRYCode}
                    footer={null}
                    title={<div style={{textAlign: "center"}}>查看荣誉编号</div>}
                    destroyOnClose={true}
                    width={1000}
                    style={{top: '20%'}}
                    className="team-honor-edit-show-modal"
                    zIndex={1001}
                >
                    <Table columns={columns}
                           locale={app.tbLocale(ry_loading)}
                           loading={ry_loading}
                           dataSource={rycodeList}
                           size="small"
                           scroll={{y: 400}}
                           pagination={false}
                    />
                </Modal>
                <Modal
                    visible={plist_visible}
                    onCancel={this.handleClosePlayer}
                    footer={null}
                    destroyOnClose={true}
                    width={800}
                    style={{top: '20%'}}
                    className="team-honor-edit-show-modal"
                    zIndex={1002}
                >
                    <Table columns={columns2}
                           locale={app.tbLocale(plist_loading)}
                           loading={plist_loading}
                           dataSource={playerList}
                           size="small"
                           scroll={{y: 400}}
                           pagination={{
                               pageSize: 20,
                               total: ptotal,
                               onChange: async (page) => {
                                    await this.handlePlayerData(page);
                               }
                           }}
                    />
                </Modal>
            </div>
        );
    }
}

export default TeamHonorEdit;



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamHonorEdit.jsx